module.exports = __webpack_public_path__ + "img/display-browser-screenshot-phone-frame-with-shadow.c3d388be.png";